import { render, staticRenderFns } from "./LocationAgreePage.vue?vue&type=template&id=34daf85a"
import script from "./LocationAgreePage.vue?vue&type=script&lang=js"
export * from "./LocationAgreePage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports